export default {
  systemUserId: {
    value: null,
    required: true,
    state: null
  },
  threeCUser: {
    value: '',
    required: true,
    state: null,
    maxlength: 50
  },
  threeCPassword: {
    value: '',
    required: true,
    state: null,
    maxlength: 100
  },
  enabled: {
    value: false,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros/threeCPlus/threeCPlusUser-form.js